export default __webpack_public_path__ + "static/pfizer-logo-80f46adcda8be0d73c72125135290da2.png";